export default function Search(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='38.514'
      height='34.986'
      viewBox='0 0 38.514 34.986'
      fill='#152a46'
      {...props}
    >
      <path
        id='search'
        d='M34.494,31.992l-7.875-7.875a14.571,14.571,0,0,0,2.3-4.225,14.932,14.932,0,0,0,.861-5.045,14.216,14.216,0,0,0-1.189-5.783,14.57,14.57,0,0,0-3.179-4.717,15.566,15.566,0,0,0-4.737-3.2A14.653,14.653,0,0,0,14.889,0,14.653,14.653,0,0,0,9.105,1.148a15.566,15.566,0,0,0-4.737,3.2A14.57,14.57,0,0,0,1.189,9.064,14.216,14.216,0,0,0,0,14.848a14.316,14.316,0,0,0,1.189,5.824,14.57,14.57,0,0,0,3.179,4.717,15.566,15.566,0,0,0,4.737,3.2,14.653,14.653,0,0,0,5.783,1.148,14.241,14.241,0,0,0,4.963-.861,17.592,17.592,0,0,0,4.307-2.3l7.875,7.875a1.692,1.692,0,0,0,.636.41,1.5,1.5,0,0,0,1.189,0,1.717,1.717,0,0,0,.636-2.871ZM3.527,14.848a11.52,11.52,0,0,1,.861-4.43,11.93,11.93,0,0,1,2.44-3.609,10.835,10.835,0,0,1,3.63-2.42,10.876,10.876,0,0,1,4.43-.9,10.876,10.876,0,0,1,4.43.9,10.835,10.835,0,0,1,3.63,2.42,11.93,11.93,0,0,1,2.44,3.609,11.52,11.52,0,0,1,.861,4.43,11.188,11.188,0,0,1-3.322,8.08h0a11.454,11.454,0,0,1-3.609,2.44,11.093,11.093,0,0,1-4.43.882,10.876,10.876,0,0,1-4.43-.9,11.373,11.373,0,0,1-6.07-6.07A11.322,11.322,0,0,1,3.527,14.848ZM38.514,34.986'
      />
    </svg>
  )
}
